import { isPlatformServer } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QatchComponent } from 'src/app/components/qatch.component';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { UserService } from 'src/app/shared/services/user.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { QuickSignUpComponent } from 'src/app/pages/auth/quick-sign-up/quick-sign-up.component';

export interface IProductMeta {
  type: string,
  page: string,
  pageType: string,
  pageOwnerId: string,
  uiTaggingKey: string,
  hideReaction?: boolean,
  alwaysShowRection?: boolean
}

@Component({
  selector: 'uikit-product',
  templateUrl: './uikit-product.component.html',
  styleUrls: ['./uikit-product.component.scss']
})
export class UikitProductComponent extends QatchComponent implements OnInit {
  private readonly isServer = isPlatformServer(inject(PLATFORM_ID));
  @Input() index: any;
  @Input() data: any;
  @Input() isCollectionPage = false;
  @Input() maxShowIndex: number;
  @Input() productMeta: IProductMeta;
  @Input() lovedCount = 0;
  @Input() loading = false;
  @Output() onClick = new EventEmitter();
  @Input() showReactionButton: boolean = true;
  @Output() updateReaction = new EventEmitter();
  @Output() onError = new EventEmitter();
  shareBtnIcon: string;
  shareBtn: any = {
    icon: 'bi-cursor-fill',
    text: `Share with friends`
  };
  constructor(
    private userService: UserService,
    private toastService: ToastService,
    protected override deviceService: DeviceDetectorService,
    protected override authService: AuthService,
    private modalService: NgbModal,
  ) {
    super(deviceService, authService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.evalshareBtnIcon();
  }

  productUrl(product: any): string {
    if (!product) return '#';

    if (product.availability_id === 2 || !product.affiliate_link) {
      return '#';
    } else if (this.isServer && product.product_id) {
      return `http://redirect.joinqatch.com/products/${encodeURIComponent(product.product_id)}`;
    } else {
      return this.userService.affiliateLinkWithTrackingParam(product);
    }
  }

  handleCardClick(event: Event, product: any) {
    event.preventDefault();
    if (!product) return;

    if (product.availability_id === 2 || !product.affiliate_link) {
      return;
    }

    this.onClick.emit(this.data);
  }

  addToQatch() {
    if (this.ifActionAllowed()) {
      this.userService.addToMyQatches(this.prepareAddToQatchRequestData())
        .subscribe({
          next: res => {
            this.data.added = this.data.added ? true : !this.data.added;
          },
          error: (error) => {
            this.toastService.error((error.error && error.error.error) || `Couldn't be added to your Qatch. Please try again.`);
          }
        })
    }
  }

  async addToQatchWithReaction(reaction: any, event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (this.loading || (reaction === this.data.reaction_type)) return;
    if (this.ifActionAllowed()) {
      const requestData = {
        reaction_type: reaction,
        ...this.prepareAddToQatchRequestData()
      };
      this.updateReaction.emit({ product: this.data, requestData });
    }
  }

  prepareAddToQatchRequestData() {
    return {
      product_id: this.data.product_id,
      retailer_id: this.data.retailer_id,
      affiliate_link: this.data.affiliate_link,
      queueing_method_detail: {
        "page": this.productMeta.page,
        "page_type": this.productMeta.pageType,
        "page_owner_id": this.productMeta.pageOwnerId
      }
    }
  }

  ifActionAllowed() {
    if (this.isLoggedIn) {
      return true;
    } else {
      this.openQuickSignUp();
      return false;
    }
  }



  openQuickSignUp() {
    this.modalService.open(QuickSignUpComponent, {
      centered: true, size: 'md', windowClass: 'quick-popup'
    });
  }

  evalshareBtnIcon() {
    const date = new Date();
    if ([10, 11].includes(date.getMonth())) {
      this.shareBtn.icon = 'bi-gift-fill';
      this.shareBtn.text = 'Tell someone you want this';
    }
  }

  getAnalyticClass(cls: any) {
    return this.productMeta?.uiTaggingKey ? `${this.productMeta.uiTaggingKey.toLowerCase()}_product_${cls}` : '';
  }

  async shareWithFriends(product: any) {
    if (this.ifActionAllowed()) {
      this.userService.referAProduct(product);
    }
  }

}
